import VSelectAdministratorRole from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectAdministratorRole', VSelectAdministratorRole),
};
